module.exports = __webpack_public_path__ + "media/images/landing/people_full_old_opt-fed75a173da00fa8ef1e04f27963fbcf.png";